module.exports = __webpack_public_path__ + "img/directory_bg.aa8df05.svg";